import { render, staticRenderFns } from "./tr.vue?vue&type=template&id=47c6dc26&scoped=true"
import script from "./tr.vue?vue&type=script&lang=js"
export * from "./tr.vue?vue&type=script&lang=js"
import style0 from "./tr.vue?vue&type=style&index=0&id=47c6dc26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6dc26",
  null
  
)

export default component.exports